// extracted by mini-css-extract-plugin
export var boxItems = "_67-1";
export var button = "_67-5";
export var filterGroupBox = "_67-0";
export var icon = "_67-2";
export var iconSecondary = "_67-4";
export var iconWrapper = "_67-3";